export const EMPLOYEE_INFO_DATA_ROLE: App.OptionsFnc = (t) => [
  { label: t('basic_setting.admin'), value: '1' },
  { label: t('basic_setting.view_only'), value: '2' },
];
